<template lang="html">
  <div>
    <md-layout v-if="ready">
      <md-layout md-flex="40" md-flex-small="100" md-flex-xsmall="100">
        <md-layout style=" padding:20px; min-height: 400px" md-align="center">
          <span v-for="(imagen, index) in imagenes">
            <!-- <img style="" :id="`img`" 
              v-if="articulo.foto && articulo.foto.replace(/ /g,'') !== '' && articulo.foto.replace(/ /g,'') !== null" :src="`${parametros.ruta_imagen}${articulo.foto}`" />
            <img style="max-height:200px;" id="" v-else src="../../assets/img/SuperticketElefanteC.png" alt="No se encontro la imagen" /> -->
            <img style="" :id="`img`" :src="`${parametros.ruta_imagen}${imagen.link}`" v-if="idImagen == imagen.idinterno && imagen.imagen == 0" />

            <iframe style="height:350px" width="560" height="400px" :src="youtube(imagen.link)" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen v-if="idImagen == imagen.idinterno && imagen.imagen==1"></iframe>
          </span> 
        </md-layout>
        <md-layout md-flex="100">
          <md-layout v-for="(imagen, index) in imagenes" md-flex="20" md-align="center" style="min-height:50px;margin-top:10px">
            <span @click="idImagen = imagen.idinterno" style="">
              <img style="" :id="`img`" width="50px" :src="`${parametros.ruta_imagen}${imagen.link}`" v-if="imagen.imagen == 0" />
              <img style="margin-top:10px" :id="`img`" width="50px" height="50px" src="../../assets/img/video.png" v-if="imagen.imagen == 1" />
            </span>
          </md-layout>

        </md-layout>
      </md-layout>
      
      <md-layout md-flex="60" md-flex-small="100" md-flex-xsmall="100">
        <md-layout md-column md-flex-small="100" md-flex-xsmall="100" md-flex="100">
          <div v-if="!parametros.existencia_negativa === '0' && !articulo.servicio == 'false'">En existencia: {{articulo.existencia}}</div>
          <h2 style="font-size:16px;">{{articulo.descripcion}}</h2>
          <p style="text-align: justify;min-height:200px">{{articulo.observacion}}</p>            
          <md-layout md-align="end" v-if="articulo.oferta">
            <label class="precioNormal" v-if="parametros.ocultar_precios == 0 || isLogged">
              {{articuloPrecio(articulo.precioAnt)}}
            </label>
          </md-layout>
          <md-layout md-align="end">
            <label class="precio" v-if="parametros.ocultar_precios == 0 || isLogged">
              {{articuloPrecio(articulo.precio)}}
            </label>
          </md-layout>
        </md-layout>
        <md-layout md-row md-gutter="16" v-if="secundarias.length > 0" md-flex="100">
          <md-layout md-flex="100" md-flex-small="100" md-flex-xsmall="100">
            <md-input-container>
              <label for="">Color y talla</label>
              <md-select
                id="colorSlct"
                tabindex="8"
                required
                v-model="idSecundaria"
                @selected="setIdSecundaria()">
                <md-option v-for="secundaria in secundarias" :value="secundaria.idinterno">
                  {{secundaria.color}} {{secundaria.talla.replace(/ /g,'') !== '' ? `- ${secundaria.talla}` : ''}}
                </md-option>
              </md-select>
            </md-input-container>
          </md-layout>
        </md-layout>  
        <md-layout md-row md-flex="100">
          <md-layout md-flex md-flex-small="100" md-flex-xsmall="100">
            <md-radio :disabled="articulo.presentacion2 === null || articulo.presentacion2.replace(/ /g,'') === ''" v-model="presentacion" class="md-primary" id="my-test1" name="my-test-group1" md-value="1"
            v-if="articulo.presentacion1" @change="precioStshopPresentacion(articulo, 1)">{{articulo.presentacion1}}</md-radio>
          </md-layout>
            <md-layout md-flex md-flex-small="100" md-flex-xsmall="100">
            <md-radio v-model="presentacion" class="md-primary" id="my-test2" name="my-test-group1" md-value="2"
              v-if="articulo.presentacion2 && articulo.presentacion2.replace(/ /g,'') !== ''" @change="precioStshopPresentacion(articulo, 2)">{{articulo.presentacion2}}</md-radio>
          </md-layout>
          <md-layout md-flex md-flex-small="100" md-flex-xsmall="100">
            <md-radio v-model="presentacion" class="md-primary" id="my-test3" name="my-test-group1" md-value="3"
              v-if="articulo.presentacion3 && articulo.presentacion2.replace(/ /g,'') !== ''" @change="precioStshopPresentacion(articulo, 3)">{{articulo.presentacion3}}</md-radio>
          </md-layout>
        </md-layout>
        <md-layout md-row v-if="parametros.ocultar_precios == 0 || isLogged" md-flex="100">
          <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
            <md-input-container>
              <label>Cantidad</label>
              <md-input v-model="cantidad"
                type="number"
                @change.native="calculateTotal"
                min="1"
                maxlength="5"
                max="99999"></md-input>
            </md-input-container>
          </md-layout>
          <md-layout md-flex="50" md-align="end" md-flex-small="100" md-flex-xsmall="100" >
            <label class="precio">
            Total:    {{toMoney(articulo.precio * cantidad)}}
            </label>
          </md-layout>
        </md-layout>
      </md-layout>
    </md-layout>
    <md-layout md-flex="100" md-align="end">
      <md-button class="md-accent" @click.native="closeDetalles">Cancelar</md-button>

      <md-button v-if="parametros.existencia_negativa === '0' && articulo.servicio == 'false'" :disabled="secundarias.length > 0 && idSecundaria === null || articulo.existencia < cantidad" class="md-primary md-raised" @click.native="addToCart">
        Agregar
        <md-tooltip v-if="secundarias.length > 0 && idSecundaria === null">
          Debes seleccionar color y talla
        </md-tooltip>
      </md-button>

      <md-button v-else :disabled="(secundarias.length > 0 && idSecundaria === null) || !(parametros.ocultar_precios == 0 || isLogged)" class="md-primary md-raised" @click.native="addToCart">
        Agregar
        <md-tooltip v-if="secundarias.length > 0 && idSecundaria === null">
          Debes seleccionar color y talla
        </md-tooltip>
      </md-button>
    </md-layout>

    <md-layout>
      <md-tabs class="md-transparent">
        <md-tab id="caracteristicas" md-label="Caracteristicas">
          <p v-for="car in caracteristicas">{{car.detalle}}</p>
        </md-tab>

        <md-tab id="especificaciones" md-label="Especificaciones">

          <md-layout v-for="esp in especificaciones" md-flex="100" style="border-bottom:1px solid #ccc; margin:10px 0">
            <md-layout style="font-size:16px; margin-bottom:10px" 
              md-flex-xlarge="20"
              md-flex-large="20"
              md-flex-medium="20"
              md-flex-small="50"
              md-flex-xsmall="50">
              {{esp.titulo}}
            </md-layout>

            <md-layout style="font-size:16px; margin-bottom:10px" 
              md-flex-xlarge="20"
              md-flex-large="20"
              md-flex-medium="20"
              md-flex-small="50"
              md-flex-xsmall="50"
              >
              {{esp.descripcion}}
            </md-layout>

           

          </md-layout>
        </md-tab>
      </md-tabs>
    </md-layout>
    
    
  </div>
</template>

<script type="text/javascript">
import { toMoney } from "../../common/functions/helpers";

export default {
  name: "Articulo",
  data() {
    return {
      resourcePedido: this.$api.pedido(this.$resource),
      resourceCliente: this.$api.cliente(this.$resource),
      resourceArticulos: this.$api.articulo(this.$resource),
      idArticulo: "",
      articulo: {},
      cantidad: 1,
      idSecundaria: null,
      parametros: {},
      secundarias: [],
      isLogged: false,
      presentacion: 1,
      idImagen: "A_H39",
      imagenes: [],
      caracteristicas:[],
      especificaciones: [],
      ready:false
    };
  },
  computed: {},
  components: {},
  methods: {
    getArticulo(idArticulo) {
      this.resourceArticulos
        .buscarById({ idArticulo })
        .then(response => {
          try {
            this.articulo = response.body;
            // this.getSecundarias(this.articulo.idinterno);
            this.precioStshopPresentacion(this.articulo);
            this.articulo.id_presentacion = 1;
            this.articulo.oferta = this.articulo.ofertaStShop !== null && this.articulo.ofertaStShop !== '' && parseFloat(this.articulo.ofertaStShop) !== 0;
            this.articulo.precioAnt = this.precioStshop(this.articulo, false);
            this.articulo.precio = this.precioStshop(this.articulo, this.articulo.oferta);
            this.articulo.existencia = this.getExistencia(
              this.articulo.existencias
            );
          } catch (e) {
            alert(e);
          }
        })
        .catch(err => {
          this.$error(this, err);
        });
    },
    youtube(link){
      const a = link.split('=');
      return 'https://www.youtube.com/embed/' + a[1];
    },
    getDetalles() {
      this.resourceArticulos
        .getDetalles({ idArticulo: this.idArticulo })
        .then(response => {
          try {
            this.imagenes = response.data.imagenes;
            this.idImagen = this.imagenes[0].idinterno;
            this.caracteristicas = response.data.detalles;
            this.especificaciones = response.data.especificaciones;
            this.ready = true;
          } catch (e) {
            alert(e);
          }
        })
        .catch(err => {
          this.$error(this, err);
        });
    },
    articuloPrecio(precio) {
        if (precio) {
          return toMoney(parseFloat(precio, 10)); 
        }
        return 0.00;
      },
    calculateTotal() {
      this.cantidad = this.cantidad < 1 ? 1 : this.cantidad;
      debugger;
      this.articulo.precioTotal = (this.cantidad * parseFloat(this.articulo.precioN).toFixed(2)) * this.articulo.moneda.cotizacion;
      this.articulo.impuestos = this.cantidad * (parseFloat(this.articulo.precio).toFixed(2) - (parseFloat(this.articulo.precioN).toFixed(2)) * this.articulo.moneda.cotizacion);
    },
    precioStshopPresentacion(articulo, presentacion) {
      let precio = "";
      const usuario = localStorage.getItem("cliente")
        ? JSON.parse(localStorage.getItem("cliente"))
        : {};
      let idlistaprecio =
        usuario.cliente &&
        usuario.cliente.idlistaprecio &&
        usuario.cliente.idlistaprecio.trim() !== ""
          ? usuario.cliente.idlistaprecio
          : "STSHOP    ";
      if (articulo.precios) {
        this.articulo.precio = 0;
        while (this.articulo.precio == 0 || this.articulo.precio == undefined) {
          articulo.precios.forEach(element => {
            if (element.idlistaprecio === idlistaprecio) {
              if (this.articulo) {
                this.articulo.id_presentacion = presentacion;
                this.articulo.pIeps = articulo.ieps
                  ? articulo.ieps.porcentaje / 100 + 1
                  : 1;
                this.articulo.pIva = articulo.iva
                  ? articulo.iva.porcentaje / 100 + 1
                  : 1;
                switch (presentacion) {
                  case 1:
                    this.articulo.precioN = articulo.oferta ? parseFloat(articulo.ofertaStShop).toFixed(2) :  parseFloat(element.precio1).toFixed(2); 
                    this.articulo.precio =
                      parseFloat(element.precio1).toFixed(2) *
                      parseFloat(this.articulo.pIeps).toFixed(2) *
                      parseFloat(this.articulo.pIva).toFixed(2);
                    break;
                  case 2:
                    this.articulo.precioN = parseFloat(element.precio2).toFixed(
                      2
                    );
                    this.articulo.precio =
                      parseFloat(element.precio2).toFixed(2) *
                      parseFloat(this.articulo.pIeps).toFixed(2) *
                      parseFloat(this.articulo.pIva).toFixed(2);
                    break;
                  case 3:
                    this.articulo.precioN = parseFloat(element.precio3).toFixed(
                      2
                    );
                    this.articulo.precio =
                      parseFloat(element.precio3).toFixed(2) *
                      parseFloat(this.articulo.pIeps).toFixed(2) *
                      parseFloat(this.articulo.pIva).toFixed(2);
                    break;
                  default:
                    this.articulo.precioN = articulo.oferta ? parseFloat(articulo.ofertaStShop).toFixed(2) :  parseFloat(element.precio1).toFixed(2); 
                    this.articulo.precio =
                      parseFloat(element.precio1).toFixed(2) *
                      parseFloat(this.articulo.pIeps).toFixed(2) *
                      parseFloat(this.articulo.pIva).toFixed(2);
                }
                if (this.articulo.precio == 0) {
                  idlistaprecio = "STSHOP    ";
                }
              }
            }
          });
        }
      }
    },
    getExistencia(existencias) {
      let existencia = "";
      existencias.forEach(element => {
        if (element.idalmacen === this.parametros.almacen) {
          existencia = element.existencia;
        }
      });
      return existencia;
    },
    getPrecio(articulo, idlistaprecio, oferta) {
      let precio = "";
      if(!oferta){
        articulo.precios.forEach(element => {
          if (element.idlistaprecio === idlistaprecio) {
            const ieps = articulo.ieps ? articulo.ieps.porcentaje / 100 + 1 : 1;
            const iva = articulo.iva ? articulo.iva.porcentaje / 100 + 1 : 1;
            const precioIeps = parseFloat(element.precio1).toFixed(2) * ieps;
            precio =
              parseFloat(precioIeps).toFixed(2) *
              iva *
              articulo.moneda.cotizacion;
          }
        });
      } else {
        const ieps = articulo.ieps ? articulo.ieps.porcentaje / 100 + 1 : 1;
            const iva = articulo.iva ? articulo.iva.porcentaje / 100 + 1 : 1;
            const precioIeps = parseFloat(articulo.ofertaStShop).toFixed(2) * ieps;
            precio =
              parseFloat(precioIeps).toFixed(2) *
              iva *
              articulo.moneda.cotizacion;
      }
      return precio;
    },
    precioStshop(articulo, oferta) {
      let precio = "";

      const usuario = localStorage.getItem("cliente")
        ? JSON.parse(localStorage.getItem("cliente"))
        : {};
      let idlistaprecio =
        usuario.cliente && usuario.cliente.idlistaprecio
          ? usuario.cliente.idlistaprecio
          : "STSHOP    ";

      if (articulo.precios) {
        precio = this.getPrecio(articulo, idlistaprecio, oferta);
        if (idlistaprecio !== "STSHOP    " && (precio === "" || precio === 0)) {
          idlistaprecio = "STSHOP    ";
          precio = this.getPrecio(articulo, idlistaprecio, oferta);
        }
      }
      return precio;
    },
    getParametros() {
      this.resourceCliente
        .parametros()
        .then(response => {
          const parametros = {};
          response.body.data.forEach(el => {
            switch (el.descripcion.trim()) {
              case "almacen":
                parametros.almacen = el.parametro.trim();
                break;
              case "pago":
                parametros.pago = el.parametro.trim();
                break;
              case "envio":
                parametros.envio = el.parametro.trim();
                break;
              case "ruta_imagen":
                parametros.ruta_imagen = el.parametro.trim();
                break;
              case "existencia_negativa":
                parametros.existencia_negativa = el.parametro.trim();
                break;
              case "sitio":
                parametros.sitio = el.parametro.trim();
                break;
              case "subdepto_descr":
                parametros.subdepto_descr = el.parametro.trim();
                break;
              case "categoria":
                parametros.categoria = el.parametro.trim();
                break;
              case "categoria_descr":
                parametros.categoria_descr = el.parametro.trim();
                break;
              case "tipoproducto":
                parametros.tipoproducto = el.parametro.trim();
                break;
              case "tipoproducto_descr":
                parametros.tipoproducto_descr = el.parametro.trim();
                break;
              case "ano":
                parametros.ano = el.parametro.trim();
                break;
              case "ano_descr":
                parametros.ano_descr = el.parametro.trim();
                break;
              case "departamento":
                parametros.departamento = el.parametro.trim();
                break;
              case "departamento_descr":
                parametros.departamento_descr = el.parametro.trim();
                break;
              case "subdepto":
                parametros.subdepto = el.parametro.trim();
                break;
              case "envio_por_cobrar":
                parametros.envio_por_cobrar = el.parametro.trim();
                break;
              case "metodo_envio":
                parametros.metodo_envio = el.parametro.trim();
                break;
              case "porcentaje_envio":
                parametros.porcentaje_envio = el.parametro.trim();
                break;
              case "articulo_envio":
                parametros.articulo_envio = el.parametro.trim();
                break;
              case "ocultar_precios":
                parametros.ocultar_precios = el.parametro.trim();
                break;
              case "pagos_meses":
                parametros.pagos_meses = el.parametro.trim();
                break;
            }
          });
          localStorage.setItem("parametros", JSON.stringify(parametros));
          this.parametros = parametros;
          if (this.articulos) {
            this.articulos.map(articulo => {
              articulo.precio = this.precioStshop(articulo);
              articulo.existencia = this.getExistencia(articulo.existencias);
            });
          }
        })
        .catch(err => {
          this.$error(this, err);
        });
    },
    toMoney,
    setIdSecundaria() {
      this.articulo.idsecundaria = this.idSecundaria;
    },
    getSecundarias(idArticulo) {
      this.resourceArticulos
        .buscarSecundaria({ idArticulo })
        .then(response => {
          this.secundarias = response.data.data;
        })
        .catch(err => {
          this.$error(this, err);
        });
    },
    addToCart() {
      if (
        this.articulo.existencia < this.cantidad &&
        this.parametros.existencia_negativa === "0" &&
        this.articulo.servicio == false
      ) {
        this.$toast.create(
          "Lamentablemente no contamos con la cantidad de articulos seleccionados",
          "snack",
          3e3
        );
        return;
      }
      const cart = window.cart ? window.cart : [];
      this.articulo.cantidad = this.cantidad;
      this.articulo.presentacion = this.presentacion;
      this.calculateTotal();
      cart.push(this.articulo);
      window.cart = cart;
      localStorage.setItem("cart", JSON.stringify(cart));
      this.idSecundaria = null;
      this.$toast.create("Articulo agregado al carrito", "snack", 3e3);
      this.$root.$emit("setcart", cart);
    }
  },
  mounted() {
    this.cart = window.cart;
    this.isLogged = localStorage.getItem("cliente") ? true : false;
    this.idArticulo = this.$route.params.idArticulo;
    this.getParametros();
    this.cliente = localStorage.getItem("cliente")
      ? JSON.parse(localStorage.getItem("cliente"))
      : {};
    this.getArticulo(this.idArticulo);
    this.getSecundarias(this.idArticulo);
    this.getDetalles();
    localStorage.setItem("ultimaPagina", 'articulo');
  }
};
</script>

<style lang="scss">
    // .articulo-card{
    //     margin:10px;
    //     width:100%;
    //     img{
    //        max-height: 130px;
    //        max-width: 130px;
           
    //     }
    //     .descripcion {
    //         // height:215px;
    //         text-align: justify;
    //         height:50px;
    //         margin-bottom:10px;
    //         .md-tooltip{
    //             max-width: 100px !important;
    //         }
    //     }
    //     .md-card-actions{
            
    //     }
    // }
    // #dialogDetalle{
    //   .md-dialog{
    //     width:650px;
    //     }
    // }
    // .precio{
    //   font-size: 18px;
    //   font-weight: bold;
    //   opacity: .8;
    //   margin-top: 20px;
    // }
    // .existencia {
    //   font-size:14px;
    //   font-weight: 500;
    //   text-align: center;
    //   // margin-right: auto;
    //   padding: 5px 0px;
    //   .agotado{
    //     // background-color: #FF0000;
    //     color:#FF0000;

    //   }
    //   .disponible{
    //     // background-color: #01DF01;
    //     color:#04B431;

    //   }

    // }
</style>




// WEBPACK FOOTER //
// src/spa/articulo/articulo.vue